require('./mortgageRequestMovingExpensesSummary.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const { withRouter } = require('react-router-dom');

// @ components
const { ContentBox } = require('commonsComponents/contentBox');
const { OKBoxTitle } = require('commonsComponents/OKBoxTitle');
const { OKLink } = require('commonsComponents/OKLink');
const { LoadingSection } = require('commonsComponents/loadingSection');
const { OKTable } = require('commonsComponents/OKTable');
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell } = require('commonsComponents/OKTableCell');

// @ helper
const { FormattedText, formatText } = require('core/i18n').i18n;
const { formatAmount } = require('utilities/currencyHelper');
const MortgageRequestCurrencyHelp = require('components/mortgageRequest/mortgageRequestCurrencyHelp/mortgageRequestCurrencyHelp.js');
const { getTinText } = require('utilities/tinHelper')

class MortgageRequestMovingExpensesSummary extends React.Component {
    componentDidMount() {
        const { history, onRequestMontlyFee, mortgageRequestMortgageData } = this.props;
        const financeExpensesValue = mortgageRequestMortgageData.getIn(['data', 'importeFinanciarGastos']);

        if (!!financeExpensesValue) {
            onRequestMontlyFee(financeExpensesValue);
        } else {
            history.push('/myprofile/mortgage/panel');
        }
    }

    buildContent() {
        const { mortgageRequestMortgageData, mortgageRequestMovingExpensesData, mortgageRequestConditionsState } = this.props;
        const conditions = mortgageRequestConditionsState.get('conditions');
        const financeExpensesValue = MortgageRequestCurrencyHelp({ currency: mortgageRequestMortgageData.getIn(['data', 'importeFinanciarGastos']) });
        const totalImportMortgageFeePlusMoving = MortgageRequestCurrencyHelp({ currency:  conditions.get('importeHipoteca')});
        const initialMortgageImport = MortgageRequestCurrencyHelp({ currency: mortgageRequestMortgageData.getIn(['data', 'importeHipoteca']) });
        const monthlyFee = MortgageRequestCurrencyHelp({ currency: mortgageRequestMovingExpensesData.get('newOffer') });
        const taeValue = `${formatAmount(conditions.get('taeProd') * 100)}%`;
        const itemTerm = conditions.get('plazo');
        const itemApplicableInterest = getTinText(conditions);

        return (
            <OKTable
                id="mortgageRequestMovingExpensesSummaryTable"
                className="account-balance-today__table"
            >
                <tbody>
                    <OKTableRow>
                        <OKTableCell className="mortgage-request-moving-expenses-summary__item">
                            <FormattedText value="mortgageRequestMovingExpensesSummary-itemMovingAmount" />
                        </OKTableCell>
                        <OKTableCell className="mortgage-request-moving-expenses-summary__value">
                            {financeExpensesValue}
                        </OKTableCell>
                    </OKTableRow>
                    <OKTableRow>
                        <OKTableCell className="mortgage-request-moving-expenses-summary__item">
                            <FormattedText value="mortgageRequestMovingExpensesSummary-itemInitialMortgageImport" />
                        </OKTableCell>
                        <OKTableCell className="mortgage-request-moving-expenses-summary__value">
                            {initialMortgageImport}
                        </OKTableCell>
                    </OKTableRow>
                    <OKTableRow>
                        <OKTableCell className="mortgage-request-moving-expenses-summary__item">
                            <FormattedText value="mortgageRequestMovingExpensesSummary-ItemTotalImportMortgageFeePlusMoving" />
                        </OKTableCell>
                        <OKTableCell className="mortgage-request-moving-expenses-summary__value">
                            {totalImportMortgageFeePlusMoving}
                        </OKTableCell>
                    </OKTableRow>
                    <OKTableRow>
                        <OKTableCell className="mortgage-request-moving-expenses-summary__item">
                            <FormattedText value="mortgageRequestMovingExpensesSummary-itemTerm" />
                        </OKTableCell>
                        <OKTableCell className="mortgage-request-moving-expenses-summary__value">
                            <span>
                                {`${itemTerm} ${formatText('mortgageRequestConditions-years')}`}
                            </span>
                        </OKTableCell>
                    </OKTableRow>
                    <OKTableRow>
                        <OKTableCell className="mortgage-request-moving-expenses-summary__item">
                            <FormattedText value="mortgageRequestMovingExpensesSummary-itemApplicableInterest" />
                        </OKTableCell>
                        <OKTableCell className="mortgage-request-moving-expenses-summary__value">
                            {itemApplicableInterest}
                        </OKTableCell>
                    </OKTableRow>
                    <OKTableRow>
                        <OKTableCell className="mortgage-request-moving-expenses-summary__item">
                            <FormattedText value="mortgageRequestMovingExpensesSummary-tae" />
                        </OKTableCell>
                        <OKTableCell className="mortgage-request-moving-expenses-summary__value">
                            {taeValue}
                        </OKTableCell>
                    </OKTableRow>
                    <OKTableRow>
                        <OKTableCell className="mortgage-request-moving-expenses-summary__item">
                            <FormattedText value="mortgageRequestMovingExpensesSummary-monthlyFee" />
                        </OKTableCell>
                        <OKTableCell className="mortgage-request-moving-expenses-summary__value">
                            {monthlyFee}
                        </OKTableCell>
                    </OKTableRow>
                </tbody>
            </OKTable>
        );
    }

    render() {
        const { mortgageRequestMovingExpensesData } = this.props;
        const headerTitle = formatText('mortgageRequestMovingExpensesSummary-summaryTitle');

        let content;

        if (mortgageRequestMovingExpensesData.get('isFetching')) {
            content = <LoadingSection />;
        } else {
            content = this.buildContent();
        }

        return (
            <ContentBox>
                <div className="mortgage-request-moving-expenses-summary__title">
                    <OKBoxTitle value={headerTitle} />
                </div>
                <div className="mortgage-request-moving-expenses-summary__content">
                    {content}
                </div>
                <div className="mortgage-request-moving-expenses-summary__warning">
                    <FormattedText value="mortgageRequestMovingExpenses-legalWarningMessage"/>
                </div>
                <div className="mortgage-request-moving-expenses-summary__buttons">
                    <OKLink modifier="emphasize" name={'returnLink'}
                        to="/myprofile/mortgage/panel"
                    >
                        <FormattedText value="mortgageRequestMovingExpensesSummary-backLabel" />
                    </OKLink>
                </div>
            </ContentBox >
        );
    }
}

MortgageRequestMovingExpensesSummary.propTypes = {
    history: PropTypes.object.isRequired,
    mortgageRequestConditionsState: PropTypes.object.isRequired,
    mortgageRequestMortgageData: PropTypes.object.isRequired,
    mortgageRequestMovingExpensesData: PropTypes.object.isRequired,
    onRequestMontlyFee: PropTypes.func.isRequired
}

module.exports = withRouter(MortgageRequestMovingExpensesSummary);
